import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./auth/authSlice";
import productReducer from "./products/productSlice";
import orderReducer from "./orders/orderSlice";
import verificationReducer from "./verification/verificationSlice";
import logisticsReducer from "./logistics/logisticsSlice";
import vendorReducer from "./vendors/vendorSlice";
import restaurantsReducer from "./restaurants/restaurantsSlice";
import restaurantOrdersReducer from "./restaurantOrders/restaurantOrdersSlice";
import restaurantOverviewReducer from "./restaurantOverview/restaurantOverviewSlice";
import feeReducer from "./fees/feeSlice";
import userReducer from "./users/userSlice";
import warehouseReducer from "./warehouse/warehouseSlice";
import stateGovReducer from "./stateGov/stateGovSlice";
import churchReducer from "./church/churchSlice";
import privateOrgReducer from "./privateOrg/privateOrgSlice";
import notificationReducer from "./notifications/notificationSlice";
import transactionReducer from "./transactions/transactionSlice";
import blacklistReducer from "./blacklist/blacklistSlice";
import agentsReducer from "./agents/agentsSlice";
import restaurantFinanceReducer from "./restaurantFinance/restaurantFinanceSlice";
import mealManagementReducer from "./mealManagement/mealManagementSlice";
import pendingOrdersReducer from "./slices/pendingOrdersSlice";
import pendingOrdersApiReducer from "./slices/pendingOrdersApiSlice";
import restaurantReportsReducer from "./restaurantReports/restaurantReportsSlice";
import restaurantIssuesReducer from "./restaurantIssues/restaurantIssuesSlice";
import restaurantCommunicationReducer from "./restaurantCommunication/restaurantCommunicationSlice";
import restaurantAppealsReducer from "./restaurantAppeals/restaurantAppealsSlice";
import paystackReducer from "./paystack/paystackSlice";
import inventoryReducer from "./inventory/inventorySlice";
import rewardsReducer from "./rewards/rewardsSlice";
import contactMessagesReducer from "./contactMessages/contactMessagesSlice";
import orderProcessingReducer from "./orderProcessing/orderProcessingSlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    products: productReducer,
    orders: orderReducer,
    verification: verificationReducer,
    logistics: logisticsReducer,
    vendors: vendorReducer,
    restaurants: restaurantsReducer,
    restaurantOrders: restaurantOrdersReducer,
    restaurantOverview: restaurantOverviewReducer,
    fees: feeReducer,
    users: userReducer,
    warehouse: warehouseReducer,
    stateGovs: stateGovReducer,
    churches: churchReducer,
    privateOrgs: privateOrgReducer,
    notifications: notificationReducer,
    transactions: transactionReducer,
    blacklist: blacklistReducer,
    agents: agentsReducer,
    restaurantFinance: restaurantFinanceReducer,
    mealManagement: mealManagementReducer,
    pendingOrders: pendingOrdersReducer,
    pendingOrdersApi: pendingOrdersApiReducer,
    restaurantReports: restaurantReportsReducer,
    restaurantIssues: restaurantIssuesReducer,
    restaurantCommunication: restaurantCommunicationReducer,
    restaurantAppeals: restaurantAppealsReducer,
    paystack: paystackReducer,
    inventory: inventoryReducer,
    rewards: rewardsReducer,
    contactMessages: contactMessagesReducer,
    orderProcessing: orderProcessingReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
